import React, { Component } from 'react';
import dataProvider, { GET_LIST } from 'providers/dataProvider';
import MultiselectComponent from './MultiselectComponent';
import ProgressBar from 'components/ui_components/ProgressBar/ProgressBar';

/**
 * ResourceMultiSelectContainer
 *
 * A dropdown-with-checkboxes input that:
 *  1. Fetches options from an API endpoint via `input.resourceAccessor(options)`
 *  2. Renders them using the existing MultiselectComponent (MUI Select + checkboxes)
 *  3. Reports selected values as an array to withForm via handleInputs
 *
 * Config fields (in inputsByHash entry):
 *   resourceAccessor: (options) => string   — builds the API resource URL
 *   accessor:         (item)    => { value, label }  — maps each API item
 *   label:            string    — dropdown label
 */
class ResourceMultiSelectContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: [],
            loading: false,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        // Re-fetch if the options context changes (e.g. reqID changes)
        if (JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options)) {
            this.loadData();
        }
    }

    getResource = () => {
        const { input, options } = this.props;
        try {
            return input.resourceAccessor ? input.resourceAccessor(options) : null;
        } catch {
            return null;
        }
    };

    loadData = () => {
        const { input } = this.props;
        const resource = this.getResource();
        if (!resource) return;

        this.setState({ loading: true });

        dataProvider(GET_LIST, resource, { filter: {} })
            .then(({ data }) => {
                const options = data.map(input.accessor);
                this.setState({ options, loading: false });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    handleChange = (e) => {
        const { inputId } = this.props;
        const value = e.target.value; // array of selected values from MUI Select multiple
        this.props.handleInputs({ target: { value, name: inputId } });
    };

    handleClick = (e) => {
        e.stopPropagation();
    };

    render() {
        const { input, inputId } = this.props;
        const { options, loading } = this.state;

        // input.value is the current form value — ensure it's always an array
        const selectedOptions = Array.isArray(input.value) ? input.value : [];

        if (loading) return <ProgressBar />;

        return (
            <MultiselectComponent
                inputId={inputId}
                label={input.label}
                options={options}
                selectedOptions={selectedOptions}
                onClick={this.handleClick}
                onChange={this.handleChange}
                renderValue={(selected) => {
                    if (!selected || selected.length === 0) return '';
                    // Show count or labels of selected items
                    const labels = selected.map(val => {
                        const opt = options.find(o => String(o.value) === String(val));
                        return opt ? opt.label : val;
                    });
                    return labels.join(', ');
                }}
            />
        );
    }
}

ResourceMultiSelectContainer.defaultProps = {
    options: {},
};

export default ResourceMultiSelectContainer;
